//agreements
import { AxiosInstance, AxiosRequestConfig } from 'axios';

import {
  AgreementEquipsPayload,
  AgreementPayload,
  ImportPayload,
  RequestPayload,
} from './types';
import { Agreement } from './models';
const ENDPOINT = 'agreement/';

const agreements = (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getAgreements: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', Agreement>>>(ENDPOINT + 'list/', payload, config),
  postAgreement: (payload: AgreementPayload) =>
    instance.post<ApiResponse<any>>(ENDPOINT + 'create/', payload, config),
  updateAgreement: (payload: AgreementPayload) =>
    instance.post(ENDPOINT + 'update/', payload, config),
  updateAgreementEquips: (payload: AgreementEquipsPayload) =>
    instance.post(ENDPOINT + 'contract/update/', payload, config),
  getAgreementEquips: (agreementId: string) =>
    instance.get(ENDPOINT + 'contract/get/' + agreementId + '/', config),
});
export default agreements;
